import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import HomePage from './components/HomePage';
import EditContent from './components/EditContent';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    // Check if user is already logged in
    const loginStatus = localStorage.getItem('isLoggedIn');
    console.log('App.tsx - checking login status:', loginStatus);
    setIsLoggedIn(loginStatus === 'true');
    setIsLoading(false);
  }, []);

  // Listen for storage changes to update login state
  useEffect(() => {
    const handleStorageChange = () => {
      const loginStatus = localStorage.getItem('isLoggedIn');
      console.log('Storage changed, new login status:', loginStatus);
      setIsLoggedIn(loginStatus === 'true');
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route 
            path="/" 
            element={isLoggedIn ? <Navigate to="/home" replace /> : <LoginPage />} 
          />
          <Route 
            path="/login" 
            element={isLoggedIn ? <Navigate to="/home" replace /> : <LoginPage />} 
          />
          <Route 
            path="/home" 
            element={isLoggedIn ? <HomePage /> : <Navigate to="/" replace />} 
          />
          <Route 
            path="/edit-content" 
            element={isLoggedIn ? <EditContent /> : <Navigate to="/" replace />} 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
